var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_4577)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.4843,
    cy: 29.4843,
    r: 29.4843,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.9325,
    height: 21.7253,
    transform: "matrix(-1 0 0 1 47.4507 18.6211)",
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_4577",
    x: 0,
    y: 0,
    width: 66.9688,
    height: 66.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_4577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_4577",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37_4577",
    transform: "matrix(0.0022096 0 0 0.00284091 -0.0656566 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37_4577",
    width: 512,
    height: 352,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAFgBAMAAAA/StwOAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGFBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAABoAtTLAAAAB3RSTlMAJkDGs6CAC+OaYAAAAPxJREFUeNrt3EENgDAABMFKAAekCkiwgAUsYAH76Gh2RsJ+L7kx27bxtZ0CCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAghQCvC2HQMAAAAAAAAAAAAAAAAAAAAAAAAAABZzxdVfZT8BBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQoBdjjTGMAAAAAAAAAAAAAAAAAAAAAAAAAAMvJX2p6lRVAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQIBOgDvONAYAAAAAAAAAAAAAAAAAAAAAAAAAwGqeOK+yAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIEAow436cYzOz8FS7twAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.d3ea287e90a1e440edc9148fbe655393.svg";
export { ForwardRef as ReactComponent };